import ChangeEmail from '~/api/endpoints/account/ChangeEmail'
import ChangePassword from '~/api/endpoints/account/ChangePassword'
import ChangeUsername from '~/api/endpoints/account/ChangeUsername'
import AdminApproveSignUp from '~/api/endpoints/admin/AdminApproveSignUp'
import AdminSignUps from '~/api/endpoints/admin/AdminSignUps'
import SignIn from '~/api/endpoints/auth/SignIn'
import SignOut from '~/api/endpoints/auth/SignOut'
import SignUp from '~/api/endpoints/auth/SignUp'
import GetDashboardData from '~/api/endpoints/dashboard/GetDashboardData'
import MarkGameAsStale from '~/api/endpoints/dashboard/MarkGameAsStale'
import GetGameData from '~/api/endpoints/game/GetGameData'
import GetGameTime from '~/api/endpoints/game/GetGameTime'
import ApproveSpectatorRequest from '~/api/endpoints/game/InGame/ApproveSpectatorRequest'
import RequestSpectatorPermission from '~/api/endpoints/game/InGame/RequestSpectatorPermission'
import RevokeSpectatorPermission from '~/api/endpoints/game/InGame/RevokeSpectatorPermission'
import SubmitMajorAction from '~/api/endpoints/game/InGame/SubmitMajorAction'
import SubmitMinorAction from '~/api/endpoints/game/InGame/SubmitMinorAction'
import CreateGame from '~/api/endpoints/game/PreGame/CreateGame'
import GetWaitingRoomData from '~/api/endpoints/game/PreGame/GetWaitingRoomData'
import JoinGame from '~/api/endpoints/game/PreGame/JoinGame'
import KickPlayerFromWaitingRoom from '~/api/endpoints/game/PreGame/KickPlayerFromWaitingRoom'
import StartGame from '~/api/endpoints/game/PreGame/StartGame'
import GetInitialData from '~/api/endpoints/GetInitialData'

const api = {
  admin: {
    signUps: new AdminSignUps(),
    approveSignUp: new AdminApproveSignUp(),
  },
  auth: {
    signIn: new SignIn(),
    signOut: new SignOut(),
    signUp: new SignUp(),
  },
  account: {
    changeEmail: new ChangeEmail(),
    changeUsername: new ChangeUsername(),
    changePassword: new ChangePassword(),
  },
  globalData: new GetInitialData(),
  dashboard: {
    getData: new GetDashboardData(),
    markGameAsStale: new MarkGameAsStale(),
  },
  preGame: {
    getWaitingRoomData: new GetWaitingRoomData(),
    getGameData: new GetGameData(),
    getGameTime: new GetGameTime(),
    createGame: new CreateGame(),
    joinGame: new JoinGame(),
    startGame: new StartGame(),
    kickPlayer: new KickPlayerFromWaitingRoom(),
  },
  inGame: {
    submitMajorAction: new SubmitMajorAction(),
    submitMinorAction: new SubmitMinorAction(),
    requestSpectatorPermission: new RequestSpectatorPermission(),
    approveSpectatorRequest: new ApproveSpectatorRequest(),
    revokeSpectatorPermission: new RevokeSpectatorPermission(),
  },
}

export default api
